import React from 'react';
import {gql} from "apollo-boost";
import {
    CircularProgress, Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import {useQuery} from "@apollo/react-hooks";
import useStyles from '../../styles/styles';
import setDate from '../../utils/setDate';

const RedirectDataTable = ({redirectData}) => {
    const classes = useStyles();
    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"redirect-data"}>Redirect Data</Typography>
            <Paper className={classes.paper}>
                {redirectData.length && redirectData.length > 0 ? (
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell variant="head">Date Created</TableCell>
                                <TableCell variant="head">Seconds After Decision</TableCell>
                                <TableCell variant="head">IP</TableCell>
                                <TableCell variant="head">User Agent</TableCell>
                                <TableCell variant="head">Destination URL</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {redirectData.map(entry => (
                                <TableRow>
                                    <TableCell variant="body">{setDate(entry.dateCreated)}</TableCell>
                                    <TableCell variant="body">{entry.secondsElapsed}</TableCell>
                                    <TableCell variant="body">{entry.clientIpAddress || ''}</TableCell>
                                    <TableCell variant="body">{entry.userAgent}</TableCell>
                                    <TableCell variant="body">{entry.destinationUrl}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <Alert severity="warning">There are no Redirects at this time.</Alert>
                )
                }
            </Paper>
        </>
    );
};

export default RedirectDataTable;
